import { CornerDownLeft, Globe } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button, Card } from 'src/shared/components/ui'
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'src/shared/components/ui/card'
import { Input } from 'src/shared/components/ui/input'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { useExtractCompanyInfo } from './hooks'

export const ExtractCompanyInfo = ({ organizationId }) => {
  const { t } = useLocalization()
  const {
    companyUrl,
    setCompanyUrl,
    isUrlValid,
    loading,
    handleExtractCompanyInfo,
  } = useExtractCompanyInfo(organizationId)

  return (
    <Card className="mb-2">
      <CardHeader>
        <CardTitle>
          {t('Extract company information', 'Extrahera företagsinformation')}
        </CardTitle>

        <CardDescription>
          {t(
            'Enter a company URL to automatically extract company information and logos.',
            'Ange en företags-URL för att automatiskt extrahera företagsinformation och logotyper.'
          )}
        </CardDescription>
      </CardHeader>

      <CardContent>
        <Column className="gap-4">
          <Row className="gap-2">
            <div className="flex-1">
              <Input
                value={companyUrl}
                onChange={(e) => setCompanyUrl(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && isUrlValid && !loading) {
                    handleExtractCompanyInfo()
                  }
                }}
                placeholder={t(
                  'Company URL (e.g., spotify.com)',
                  'Företags-URL (t.ex., spotify.com)'
                )}
                startContent={
                  <Globe className="w-4 h-4 text-muted-foreground" />
                }
              />
            </div>

            <Button
              onClick={handleExtractCompanyInfo}
              disabled={!isUrlValid || loading}
              variant="primary"
              isLoading={loading}
            >
              <div className="border border-white rounded-sm p-0.5 mr-2">
                <CornerDownLeft className="w-3 h-3" />
              </div>
              {t('Extract info', 'Extrahera info')}
            </Button>
          </Row>

          {companyUrl && !isUrlValid && (
            <p className="text-sm text-muted-foreground">
              {t(
                'Please enter a valid company URL (e.g., spotify.com)',
                'Ange en giltig företags-URL (t.ex., spotify.com)'
              )}
            </p>
          )}
        </Column>
      </CardContent>
    </Card>
  )
}
